import { render, staticRenderFns } from "./movementForm.vue?vue&type=template&id=13263442"
import script from "./movementForm.vue?vue&type=script&lang=js"
export * from "./movementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13263442')) {
      api.createRecord('13263442', component.options)
    } else {
      api.reload('13263442', component.options)
    }
    module.hot.accept("./movementForm.vue?vue&type=template&id=13263442", function () {
      api.rerender('13263442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/movementForm.vue"
export default component.exports